/**
 * 处理会话中的模板数据
 */

import { useStores } from '@/store/hooks/useStore';
import { useEffect } from 'react';

interface UseThreadTemplateParams {}

const useThreadTemplate = ({}: UseThreadTemplateParams) => {
  const stores = useStores();
  const { fetchTemplates, handleApiNotify } = stores.threadTemplateStore;

  // fix: useThreadTemplate 获取 thread_id 和 fetchTemplates();中获取threadId的方式需保持一致，
  // 这里统一使用threadInfo 中的threadId 保证规范
  const threadId = stores.threadStore?.threadInfo?.thread_id;

  useEffect(() => {
    if (threadId) {
      fetchTemplates();
    }
  }, [threadId]);

  useEffect(() => {
    // Add event listener
    window.addEventListener('api-notify', handleApiNotify as EventListener);

    // Cleanup
    return () => {
      window.removeEventListener(
        'api-notify',
        handleApiNotify as EventListener,
      );
    };
  }, [threadId]);
};

export default useThreadTemplate;
